import InvoiceIcon from "@assets/images/invoices.svg";
import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@material-ui/core";
import DataTable from "@saleor/changeOrder/components/DataSortTable";
import MyTypography from "@saleor/components/MyTypography";
import { useSearchSuggestionShipTosforCipLazyQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { mapEdgesToItems } from "@saleor/utils/maps";
import { FormikProps } from "formik";
import uniq from "lodash/uniq";
import React, { useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import SoldToForShipToInputSuggestion from "../SoldToInputSuggestion/SoldToForShipTo";
interface addressInterface {
  code: string;
  name: string;
  addressText: string;
}
export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  address: addressInterface[] | null;
  addressType: string;
  formik?: FormikProps<any>;
  customSubmit?: (value) => void;
  handleSoldTo?: any;
  callShipToUnloading?: any;
  initialValue?: string;
}
export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "0",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      padding: "0 !important",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    labelRadio: {
      marginBottom: "2rem"
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    nameHeads: {
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    buttonWrap: {
      padding: "0px",
      marginTop: "24px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const {
    visible,
    initialValue,
    onClose,
    address,
    addressType,
    formik,
    callShipToUnloading,
    customSubmit
  } = props;
  const [selectedRow, setSelectedRow] = useState(initialValue || " ");

  const classes = useStyles();
  const intl = useIntl();
  const [
    getDataSuggestionsDemostic,
    {
      data: fetchDataSuggestionsDemostic,
      loading: loadingDataSuggestionDemostic
    }
  ] = useSearchSuggestionShipTosforCipLazyQuery({
    fetchPolicy: "no-cache"
  });
  const dataOptions = (
    mapEdgesToItems(fetchDataSuggestionsDemostic?.searchSuggestionShipTo) || []
  ).map(data => ({
    title: `${data.displayCodeName}\n${data.addressText}`,
    value: data.partnerCode,
    addressText: data.addressText,
    displayCodeName: data.displayCodeName
  }));
  const [submit, setSubmit] = useState<any>();
  function handleSelectedSearch(e) {
    if (e.value) {
      setSubmit(e);
      setSelectedRow(" ");
    }
  }
  const columns = useMemo(() => {
    switch (addressType) {
      case "billTo":
        return [
          { field: "BilltoCode", headerName: "Bill-to Code", width: 90 },
          { field: "billingAddress", headerName: "Name", width: 200 }
        ];
      case "shipTo":
      default:
        return [
          { field: "ShiptoCode", headerName: "Ship-to Code", width: 90 },
          { field: "shippingAddress", headerName: "Name", width: 200 }
        ];
    }
  }, [addressType, address]);

  const rows = useMemo(() => {
    switch (addressType) {
      case "billTo":
        return uniq(address).map(shippingAddress => ({
          BilltoCode: shippingAddress?.code,
          billingAddress: (
            <>
              <strong>{shippingAddress?.name}</strong>
              <br />
              {shippingAddress?.addressText}
            </>
          )
        }));
      case "shipTo":
      default:
        return uniq(address).map(shippingAddress => ({
          ShiptoCode: shippingAddress?.code,
          shippingAddress: (
            <>
              <strong>{shippingAddress?.name}</strong>
              <br />
              {shippingAddress?.addressText}
            </>
          )
        }));
    }
  }, [addressType, address]);
  const clearSelectVariant = () => {
    setSelectedRow(" ");
    onClose();
  };
  const dataRenderModal = useMemo(() => {
    switch (addressType) {
      case "billTo":
        return {
          iconHead: InvoiceIcon,
          nameHead: intl.formatMessage({
            defaultMessage: "Bill-to Party"
          }),
          label: intl.formatMessage({
            defaultMessage: "ข้อมูลที่อยู่สำหรับออกใบกำกับภาษีี"
          })
        };
      case "shipTo":
        return {
          iconHead: ShippingIcon,
          nameHead: intl.formatMessage({
            defaultMessage: "Ship-to Party"
          }),
          label: intl.formatMessage({
            defaultMessage: "ข้อมูลสถานที่จัดส่ง"
          })
        };
    }
  }, [addressType]);
  function handleSubmit() {
    if (customSubmit) {
      if (submit) {
        customSubmit(submit.title);
      } else if (selectedRow === "") {
        customSubmit("");
      } else {
        const shipToValue = address?.find(a => a.code === selectedRow);
        customSubmit(
          shipToValue?.code +
            " - " +
            shipToValue?.name +
            " - " +
            shipToValue?.addressText
        );
      }
      return onClose();
    }
    if (addressType === "shipTo") {
      const shipToValue = address?.find(a => a.code === selectedRow);
      if (submit) {
        formik.setFieldValue(
          "shipTo",
          submit.displayCodeName + " - " + submit.addressText
        );
        callShipToUnloading({
          shipTo: submit.value
        });
      } else {
        formik.setFieldValue(
          "shipTo",
          shipToValue?.code +
            " - " +
            shipToValue?.name +
            " - " +
            shipToValue?.addressText
        );
        callShipToUnloading({
          variables: {
            shipTo: shipToValue?.code
          }
        });
      }
      setSubmit(null);
    } else {
      const billToValue = address?.find(a => a.code === selectedRow);
      formik.setFieldValue(
        "billTo",
        billToValue?.code +
          " - " +
          billToValue?.name +
          " - " +
          billToValue?.addressText
      );
    }
    onClose();
  }

  const handleRowSelection = selectedRowIndex => {
    const shipToValue = address?.find(a => a.code === selectedRowIndex);
    setSelectedRow(shipToValue?.code);
  };
  return (
    <Dialog open={visible} className={classes.root} data-testid="modalAddress">
      <DialogTitle className={classes.dialogTitle}>
        <div className={classes.dialogTitleWrap}>
          <img src={dataRenderModal?.iconHead} alt="" />
          <MyTypography
            variant={"h6"}
            className={classes.nameHead}
            data-testid="title-name"
          >
            {dataRenderModal?.nameHead}&nbsp;
            <span className={classes.rowlength}>({rows.length})</span>
          </MyTypography>
        </div>
        {addressType === "shipTo" && (
          <MyTypography variant={"h6"} className={classes.nameHeads}>
            ค้นหา Ship-to อื่น
          </MyTypography>
        )}
      </DialogTitle>
      {addressType === "shipTo" && (
        <SoldToForShipToInputSuggestion
          searchField="search"
          dataOptions={dataOptions}
          totalCount={dataOptions.length}
          loadingDataSuggestion={loadingDataSuggestionDemostic}
          objectSuggestion
          getDataSuggestions={getDataSuggestionsDemostic}
          contained
          defaultInputValue={null}
          name={"materialOsId"}
          placeholder={"พิมพ์ค้นหา"}
          error={null}
          key={" "}
          handleSelectedSearch={handleSelectedSearch}
          formik={formik}
          id="materialOsId"
        />
      )}
      <DialogContent dividers={false} className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <DataTable
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              headCells={columns}
              rows={rows}
              onRowSelect={handleRowSelection}
              sortField={addressType === "billTo" ? "BilltoCode" : "ShiptoCode"}
              boldFields={["ShiptoCode", "partnerName"]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.buttonWrap}>
        <Button
          id="cancelButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={clearSelectVariant}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="submitButton"
          data-testid="submitButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          disabled={false}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalAddress.displayName = "ModalAddress";
export default ModalAddress;
